export const ANC_SERVICE = {
    TAB_ALBENDAZOLE : 'whether_tab_albendazole_given',
    FOLIC_ACID:'no_of_folic_acid_tabs_given',
    TD_DOSE:'tt_td_dose',
    IFA_TABS:'no_of_ifa_tabs_given',
    CALCIUM_TABS:'no_of_calcium_vitamin_d3_tabs_given',
    BLOOD_GROUP:'blood_group_and_rh_factor',
    VDRL_TEST:'syphilis_test',
    OBSTETRIC_HISTORY:'obstetric_history',
    THYROID_TEST:'thyroid_test',
    TB_SCREENING_TEST:'tb_screening_test',
    RAPID_MALARIA_TEST:'rapid_malaria_test',
    ULTRA_SOUND_SCREENING:'ultra_sound_screening',
    HIV_SCREENING_TEST:'hiv_screening_test',
    NACP_REFERRAL_FACILITY: 'referred_to_nacp_referral_facility',
    HBSAG_TEST:'hbsag_test',
    WEIGHT:'weight_in_kg',
    HEIGHT:'height_in_cm'
};

export const ANC_SERVICE_NAME = {
      PE_OBSTETRIC:'anc_pe_oh',
      ROUTINE_ANC:'anc_rout_anc',
      ANC_TD:'anc_td',
      ANC_SERVICE:'anc_anc_serv'
}

export const PNC_CHILD_SERVICE = {
    EXCLUSIVE_BREASTFEEDING_CONTINUED: 'whether_exclusive_breastfeeding_continued',
    HIV_TEST_FOR_BABY: 'hiv_screening_test',
    NACP_REFERRAL_FACILITY: 'referred_to_nacp_referral_facility',
    DANGER_SIGNS: 'indicate_danger_signs_if_any_present_for_baby',
    VISIBLE_BIRTH_DEFECTS: 'any_visible_birth_defect_seen',
    VISIBLE_BIRTH_DEFECTS_Treatment: 'any_visible_birth_defect_seen',

    METHOD_OF_TREATMENT: 'method_of_treatment',
    REFERRED_TO_HIGHER_FACILITY_FOR_DANGER_SIGNS: 'referred_to_higher_facility_for_danger_signs',
    REFERRED_TO_HIGHER_FACILITY_FOR_BIRTH_DEFECTS: 'referred_to_higher_facility_for_birth_defects',
}
export const TD_DOSE_OPTIONS = {
    TT1TD1:'tt1td_1',
    TT2TD2:'tt2td_2',
    TTBOOSTER:'tt_boostertd_b'
}

export const FACILITY_DETAILS = {
    FACILITY_NAME: 'facility_name',
    FACILITY_TYPE: 'facility_type_name',
    MOB_FIRST_NAME: 'mobiliser_f_name',
    MOB_LAST_NAME: 'mobiliser_l_name',
    HEALTH_PROVIDER_FIRST_NAME: 'healthprovider_f_name',
    HEALTH_PROVIDER_LAST_NAME: 'healthprovider_l_name',
}
export const USG_FORM = {
    ULTRA_SOUND_SCREENING: 'ultra_sound_screening'
}
export const TD_INJECTION = {
    Td_DOSE:'tt_td_dose',
};

export const ROUTINE_ANC_SERVICE={
    URINE_TEST: 'urine_test',
    FETAL_MOVEMENTS: 'fetal_movements',
    OGTT_TEST: 'ogtt_test',
    SEVERE_ANAEMIA_TREATMENT: 'severe_anaemia_treatment',
    FETAL_POSITION:'fetal_presentation_position' ,
    POST_PRANDIAL_TEST: 'post_prandial_test',
    HB: 'hb_gm',
    FUNDAL_HEIGHT: 'fundal_height_size',
    FETAL_HEART_RATE: 'fetal_heart_rate',
    OTHER_HIGH_RISK_SYMPS: 'other_high_risk_symptoms',
    BP_SYSTOLIC: 'bp_systolic_mm_hg',
    BP_DIASTOLIC: 'bp_diastolic_mm_hg',
    BLOOD_SUGAR_TEST: 'blood_sugar_test',
    WEIGHT: 'weight_in_kg'
  }

export const PREGNANCY_TAB_BACK_OBJECT = {
    benfType: "female",
    menuItems: "Pregnancy Services",
};
